<template>
	<div class="cdp">
		<div class="cdp__top">
			<div class="cdp__crumbs">
				<router-link class="cdp__crumb" :to="{ name: 'customers' }">Kunder</router-link>
				<span class="cdp__sep">›</span>
				<span class="cdp__crumb is-current">{{ name }}</span>
			</div>
			<div class="cdp__actions">
				<div class="cdp__btn" @click="edit">Rediger</div>
			</div>
		</div>

		<div class="cdp__header">
			<div class="cdp__name">{{ name }}</div>
			<div class="cdp__sub">{{ sub }}</div>
		</div>

		<div class="cdp__tabs">
			<div
				v-for="t in tabs"
				:key="t.name"
				class="cdp__tab"
				:class="{ 'is-active': active === t.name }"
				@click="active = t.name"
			>
				{{ t.label }}
				<div class="cdp__tab-mark"></div>
			</div>
		</div>

		<div class="cdp__body">
			<customer-content :cw="cw" :activity="cwActivity" :active="active" theme="light" @open="cwOpen" />
		</div>
	</div>
</template>

<script>
	import customerData from '../customer/customerData'
	import CustomerContent from '../customer/CustomerContent'
	import ContactWindow from '../windows/ContactWindow'
	import ContactModel from '../model/Contact'

	export default {
		name: 'customer-detail-page',
		mixins: [customerData],
		components: { CustomerContent },
		data() {
			return {
				active: 'overview',
				tabs: [
					{ name: 'overview', label: 'Oversigt' },
					{ name: 'orders', label: 'Ordrer' },
					{ name: 'quotes', label: 'Tilbud' },
					{ name: 'tasks', label: 'Opgaver' },
					{ name: 'packaging', label: 'Emballage' },
					{ name: 'activity', label: 'Aktivitet' }
				]
			};
		},
		computed: {
			id() { return this.$route.params.id; },
			name() { return (this.cw.contact && this.cw.contact.name) || 'Kunde'; },
			sub() {
				const c = this.cw.contact;
				if (!c) return '';
				return [c.address, [c.zip, c.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
			}
		},
		methods: {
			edit() {
				const self = this;
				this.$store.state.windowStack.push(ContactWindow, {
					value: this.cw.contact,
					submit: async function (entity) {
						if (await ContactModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.cwLoad(self.id);
						}
					}
				});
			}
		},
		mounted() {
			this.cwLoad(this.id);
		}
	};
</script>

<style lang="scss" scoped>
	.cdp {
		position: absolute;
		left: 0; top: 0; right: 0; bottom: 0;
		background: #f7f7f7;
		overflow-y: auto;
		font-family: 'Montserrat', sans-serif;
	}

	.cdp__top {
		height: 60px;
		background: #fff;
		border-bottom: 1px solid #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 30px;
	}
	.cdp__crumbs { display: flex; align-items: center; gap: 10px; font-size: 13px; }
	.cdp__crumb { color: #a7a7a7; text-decoration: none; }
	.cdp__crumb.is-current { color: #1c1d21; font-weight: 600; }
	.cdp__crumb:hover { color: #f7223f; }
	.cdp__sep { color: #a7a7a7; }
	.cdp__btn {
		font-size: 13px;
		color: #fff;
		background: #f7223f;
		border-radius: 20px;
		padding: 10px 30px;
		cursor: pointer;
	}

	.cdp__header { padding: 30px 30px 20px; }
	.cdp__name { font-size: 24px; font-weight: 700; color: #1c1d21; }
	.cdp__sub { font-size: 13px; color: #a7a7a7; margin-top: 5px; }

	.cdp__tabs {
		display: flex;
		gap: 30px;
		padding: 0 30px;
		background: #fff;
		border-bottom: 1px solid #f0f0f0;
	}
	.cdp__tab {
		position: relative;
		font-size: 14px;
		color: #a7a7a7;
		line-height: 50px;
		cursor: pointer;
	}
	.cdp__tab:hover { color: #1c1d21; }
	.cdp__tab.is-active { color: #1c1d21; font-weight: 600; }
	.cdp__tab-mark {
		position: absolute;
		left: 0; right: 0; bottom: 0;
		height: 4px;
		background: #f7223f;
		opacity: 0;
	}
	.cdp__tab.is-active .cdp__tab-mark { opacity: 1; }

	.cdp__body { max-width: 1100px; }
</style>
